

import TitleShapes from "../../assets/images/icon/title_shapes";
import TitleShapes2 from "../../assets/images/icon/title_shapes2";
import SectionTitleWrapper from "./SectionTitle.style";

const SectionTitle = ({ title, subtitle, isCenter, ...props }) => {
  return (
    <SectionTitleWrapper {...props}>
      {subtitle && (
        <h2>
          {isCenter ? <TitleShapes2 /> : ""}
          {subtitle} <TitleShapes />{" "}
        </h2>
      )}
      {title && <h3>{title}</h3>}
    </SectionTitleWrapper>
  );
};

export default SectionTitle;
